import SerializableObject from '@/utils/models/serializableobject.model';
import Kiosk from '../kiosk/kiosk.model';

export default class KioskResponse extends SerializableObject {
  Kiosk?: Kiosk;
}
